module.exports = __webpack_public_path__ + "static/media/dark-theme-vehicle-count.efc870c8.svg";